<template>
  <div>
    <div class="mb-5 w-full">
      <fieldset>
        <div class="form-group">
          <input
            v-model="searchQuery"
            type="search"
            class="form-control form-search"
            placeholder="Type to find what you are looking for"
            aria-controls="datatables"
            autofocus
          />
        </div>
        <button
          class="ml-6 btn btn-info pull-right"
          @click="toggleTableStatus()"
        >
          {{ tableStatus ? "Collapse All" : "Expand All" }}
        </button>
      </fieldset>
    </div>

    <div>
      <el-table
        class="table-striped table-with-tooltip"
        :data="queriedData"
        :default-sort="defaultSort"
        :expand-row-keys="expends"
        row-key="id"
        border
        style="width: 100%"
      >
        <el-table-column type="expand">
          <template #default="props">
            <div v-if="props.row.lessons.hasOwnProperty('previousVersion')">
              <i class="expand-button el-icon mr-10" :class="props.row.currentExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="toggleCurrentRow(props.row)"></i>
              <b>Current Version
                (All remaining lessons in this version will be scheduled for trainee completion before the expiration date)
              </b>
              <div v-if="props.row.currentExpanded || typeof props.row.currentExpanded === 'undefined'">
                <TrainingRecordLesson :lesson-list="props.row.lessons.currentVersion" />
              </div>

              <hr/>

              <i class="expand-button el-icon mr-10" :class="props.row.previousExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="togglePreviousRow(props.row)"></i>
              <b>Previous Version</b>
              <b v-if="!props.row.isTopicCompleted">
                (This version was not completed in full before the new version was released)
              </b>
              <div v-if="props.row.previousExpanded">
                <TrainingRecordLesson :lesson-list="props.row.lessons.previousVersion" />
              </div>
            </div>

            <div v-if="!props.row.lessons.hasOwnProperty('previousVersion')">
              <TrainingRecordLesson :lesson-list="props.row.lessons.currentVersion" />
            </div>

          </template>
        </el-table-column>

        <el-table-column
          prop="topicName"
          label="Name"
          min-width="450"
          sortable
          :sort-orders="['ascending', 'descending']"
        >
          <template #default="props">
            <div class="flex">
              <div v-if="!(props.row.periodicity === 'Initial only' && props.row.completed_at !== null)">
                <Icon :type="props.row.topicStatus"  class="mr-2"/>
              </div>

              <div>
                <p class="mr-3 mb-0">
                  {{ props.row.topicName }}

                  <Icon
                    v-for="condition in props.row.conditions"
                    :key="condition"
                    :type="condition"
                    class="mx-2 inline-block"
                  />

                  <el-tooltip v-if="props.row.formerTopicName != null" placement="top" class="inline-block">
                    <div slot="content">
                      Formerly known as
                      <strong class="text-warning">{{ props.row.formerTopicName }}</strong><br>
                    </div>
                    <i class="text-info fa-solid fa-circle-info" @click="openFormerNameModal(lesson)"></i>
                  </el-tooltip>
                </p>
              </div>
            </div>
            <!--Modal-->
            <el-dialog
              :modal="false"
              title="Former Topic Name"
              :visible="showFormerNameModal"
              width="40%"
              center
              @close="handleModalClose"
              @update:visible="handleModalVisibility"
            >
              <div style="text-align: center;">
                <p><strong>Current Name:</strong> {{ props.row.topicName }}</p>
                <p><strong>Former Name:</strong> {{ props.row.formerTopicName }}</p>
                <p>This Topic was renamed to better reflect its updated content.</p>
              </div>
              <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="closeFormerNameModal">Close</el-button>
      </span>
            </el-dialog>
          </template>
        </el-table-column>

        <el-table-column
          prop="periodicity"
          label="Periodicity"
          min-width="150"
          sortable
          :sort-orders="['ascending', 'descending']"
        >
          <template #default="props">
            <!-- <div v-if="props.row.periodicity === 'Initial only'">
              <el-popover trigger="hover" placement="top">
                <p>Topics with Initial Only periodicity that appear in the training record have been completed once and are not part of the recurrent program.</p>
                <div slot="reference" class="periodicity-wrapper">
                  <p>{{ props.row.periodicity }}</p>
                </div>
              </el-popover>
            </div>
            <div v-if="props.row.periodicity !== 'Initial only'">
              <p>{{ props.row.periodicity }}</p>
            </div> -->

            <div v-if="props.row.periodicity === 'Initial only'">
              <el-tooltip
                content="Topics with Initial Only periodicity that appear in the training record have been completed once and are not part of the recurrent program."
                placement="top"
              >
                <p>{{ props.row.periodicity }}</p>
              </el-tooltip>
            </div>
            <div v-if="props.row.periodicity !== 'Initial only'">
              <p>{{ props.row.periodicity }}</p>
            </div>

            <!-- <div v-if="props.row.periodicity === 'Initial only'">
              <el-tooltip
                content="Tootip"
                placement="top"
              >
                <p>{{ props.row.periodicity }}</p>
              </el-tooltip>
            </div>
            <div v-if="props.row.periodicity !== 'Initial only'">
              <el-popover trigger="hover" placement="top">
                <p>PopOver</p>
                <div slot="reference" class="periodicity-wrapper">
                  <p>{{ props.row.periodicity }}</p>
                </div>
              </el-popover>
            </div> -->

          </template>
        </el-table-column>

        <el-table-column
          prop="completed_at"
          label="Completed"
          min-width="150"
          sortable
          :sort-orders="['ascending', 'descending']"
        >
          <template #default="props">
            <template v-if="props.row.completed_at === null && props.row.expiry !== null">
              <el-tooltip
                content="Completed will be shown once this topic has been completed."
                placement="top"
              >
                <p>In Progress</p>
              </el-tooltip>
            </template>

            <template v-else-if="props.row.completed_at !== null">
              {{ formatDate(props.row.completed_at) }}
            </template>
          </template>
        </el-table-column>

        <el-table-column
          prop="expiry"
          label="Expiry"
          min-width="150"
          sortable
          :sort-orders="['ascending', 'descending']"
        >
          <template #default="props">
            <div>
              <span>
                <template v-if="props.row.completed_at === null && props.row.expiry === null">
                  <el-tooltip
                    content="Expiry will be shown once this topic has been completed."
                    placement="top"
                  >
                  <p>In Progress</p>
                </el-tooltip>
                </template>
                <template v-else-if="props.row.periodicity === 'Initial only' && props.row.completed_at !== null">
                  <!-- show empty -->
                </template>
                <template v-else-if="props.row.expiry !== null">
                  {{ formatDate(props.row.expiry) }}
                </template>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <div class="flex justify-between items-center">
      <div>
        <p class="category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        </p>
      </div>

      <p-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="pagination.total"
      />

      <div>
        <el-select
          v-model="pagination.perPage"
          class="select-default"
          placeholder="Per page"
        >
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            class="select-default"
            :label="item"
            :value="item"
          />
        </el-select>
      </div>
    </div> -->
  </div>
</template>

<script>
import Icon from "@components/UIComponents/TopicIcon/Icon";
import { Dialog } from 'element-ui';
//import PPagination from "@components/UIComponents/Pagination.vue";
import tableConfig from "@providers/table";
import Vue from "vue";
import { Tooltip, Tag, Popover, Table, TableColumn } from "element-ui";
import mapper from "@components/UIComponents/TopicIcon/mapper.json";
import { mapGetters, mapActions } from "vuex";
import HelperDate from "@helpers/dates";
import TrainingRecordLesson from "@components/Dashboard/Views/Pages/Training/Record/Components/TrainingRecordLesson";
import TrainingRecordExpiryNotesModal from "../TrainingRecordExpiryNotesModal.vue";

Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(Popover);
Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    //PPagination,
    Icon,
    TrainingRecordLesson,
    'el-dialog': Dialog,

  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      expends: [],
      tableStatus: false,
      modal: {},
      ...tableConfig.data,
      propsToSearch: ["topicName", "formerTopicName", "periodicity", "expiry", "completed_at", "conditions"],
      defaultSort: { prop: "topicName", order: "ascending" },
      showFormerNameModal: false,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    tableData() {
      return !this.data.topics ? [] : this.parseData(this.data.topics);
    },
    ...tableConfig.computed,
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseData(data) {
      return data.map((topic) => {
        return {
          id: topic.topicId,
          conditions: this.getIconConditions(topic),
          topicStatus: this.getStatus(topic.status),
          topicName: topic.topicName,
          formerTopicName: topic.formerTopicName,
          periodicity: topic.periodicity,
          completed_at: this.formatDate(topic.completed_at),
          expiry: this.formatDate(topic.expiry),
          lessons: topic.lessons,
          currentExpanded: true,
          isTopicCompleted: topic.isTopicCompleted,
        };
      });
    },
    getIconConditions(topic) {
      const conditions = [
        "seasonal",
        "compressed",
        "expiration",
        "international_procedures",
      ];
      return conditions.filter((cond) => topic[cond]);
    },
    getStatus(status) {
      if (!status) {
        return null;
      }

      const stringfiedStatus = String(status);

      const [iconName] = Object.entries(mapper).find(([, value]) => {
        return value.code === stringfiedStatus;
      });

      const rejectStatus = ["completed"];

      if (rejectStatus.includes(iconName)) {
        return null;
      }

      return iconName;
    },
    formatDate(date) {
      return HelperDate.formatDate(date);
    },
    toggleTableStatus() {
      this.tableStatus = !this.tableStatus;
      this.expends = this.tableStatus ? this.tableData.map(({ id }) => id) : [];
    },
    toggleCurrentRow(row) {
      if (!Object.prototype.hasOwnProperty.call(row, 'currentExpanded')) {
        this.$set(row, 'currentExpanded', false);
      }
      row.currentExpanded = !row.currentExpanded;
    },
    togglePreviousRow(row) {
      if (!Object.prototype.hasOwnProperty.call(row, 'previousExpanded')) {
        this.$set(row, 'previousExpanded', false);
      }
      row.previousExpanded = !row.previousExpanded;
    },
    showExpiryNotesModal(){
      return this.$modal.show(TrainingRecordExpiryNotesModal);
    },
    openFormerNameModal(lesson) {
      this.selectedLesson = lesson;
      this.showFormerNameModal = true;
    },
    closeFormerNameModal() {
      this.showFormerNameModal = false;
      this.selectedLesson = null;
    },
    handleModalClose() {
      this.showFormerNameModal = false;
      this.selectedTopic = null;
    },
    handleModalVisibility(visible) {
      this.showFormerNameModal = visible;
      if (!visible) {
        this.selectedTopic = null;
      }
    }
  },
};
</script>

<style lang="scss"></style>
